const FemaleAvatarSvg = ({ color }: { color: string }) => (
    <svg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='30' cy='30' r='28.5' fill={color} />
        <path
            d='M30.3135 34.8049C38.7126 34.9677 45.8484 39.0135 48.7705 44.6818C48.4339 45.1165 48.0829 45.5392 47.7178 45.9494C46.814 43.9327 45.3045 42.093 43.3008 40.5607C39.8932 37.9549 35.1202 36.3001 29.7871 36.3C24.4539 36.3 19.6802 37.9549 16.2725 40.5607C14.2688 42.093 12.7593 43.9327 11.8555 45.9494C11.4899 45.5388 11.1378 45.1161 10.8008 44.6809C13.7839 38.8945 21.1605 34.8 29.7871 34.8L30.3135 34.8049Z'
            fill='white'
        />
        <circle cx='29.7857' cy='21.8553' r='10.8551' stroke='white' strokeWidth='1.5' />
        <path
            d='M31.0061 13.837L34.2018 8.86992C34.4907 8.42087 35.1314 8.41534 35.435 8.82842L35.4917 8.91716L38.1026 13.7137C38.3064 14.0879 38.687 14.3328 39.112 14.3631L44.5593 14.751C45.1276 14.7915 45.4444 15.4257 45.1362 15.9048L41.9405 20.8719C41.6247 21.3625 40.8943 21.3208 40.6369 20.7972L38.2082 15.8509C38.0293 15.4868 37.6869 15.2357 37.2937 15.1696L37.1225 15.1524L31.6152 14.9929C31.0318 14.9759 30.6904 14.3278 31.0061 13.837Z'
            fill='white'
            stroke='white'
            strokeWidth='0.5'
        />
        <circle
            cx='38.0491'
            cy='14.9061'
            r='2.45699'
            transform='rotate(-43.828 38.0491 14.9061)'
            fill={color}
            stroke='white'
            strokeWidth='0.5'
        />
    </svg>
);

export default FemaleAvatarSvg;
